import { render } from "./AskDoubtTeacher.vue?vue&type=template&id=2e9269f2&scoped=true"
import script from "./AskDoubtTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtTeacher.vue?vue&type=style&index=0&id=2e9269f2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9269f2"]])

export default __exports__